var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const sentWarnings = /* @__PURE__ */ new Set();
function consoleWarn(warnings, ...rest) {
  const warningsArray = Array.isArray(warnings) ? warnings : [warnings];
  for (const warning of warningsArray) {
    const { message, prop, propValues } = warning;
    if (!sentWarnings.has(JSON.stringify(warning)) && (prop && !propValues || prop && propValues && propValues.includes(prop))) {
      console.warn(`Magnetic: ${message}`, rest);
      sentWarnings.add(JSON.stringify(warning));
    }
  }
}
__name(consoleWarn, "consoleWarn");

export { consoleWarn };
//# sourceMappingURL=console-warn.js.map
